(() => {
if (!window.gsap || !window.ScrollTrigger || !window.lottie) return;
gsap.registerPlugin(ScrollTrigger);
window.addEventListener('load', function() {
  gsap.to("body", {autoAlpha: 1, duration: 2}); // 2 seconds duration
});
if (document.getElementById('animationWindow')) {
  // Lottie Animation TOXTOX Logo
// LottieScrollTrigger({
//     target: "#animationWindow",
//     path: "https://lottie.host/51d2cccb-bd2c-4ded-854d-f1c1c59fc38f/PhMPSNlQCT.json",
//     speed: "medium",
//     pinSpacing: true,
//     onload: () => {
//         //get the target element and add a class to it
//         document.querySelectorAll("#animationWindow > svg").classList.add(".animationWindowMoblie");
//     },
//     onLeave: () => {
//         //get the target element and add a class to it
//         document.getElementById("animationWindow").classList.add("animationWindowLeave");
//     },
//     onEnterBack: () => {
//         //get the target element and remove a class from it
//         document.getElementById("animationWindow").classList.remove("animationWindowLeave");
//     },
//     scrub: 3 // seconds it takes for the playhead to "catch up"
//     // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See https://greensock.com/docs/v3/Plugins/ScrollTrigger
//    });

// Load the Lottie animation
const animation = lottie.loadAnimation({
  container: document.getElementById('animationWindow'), // the DOM element that will contain the animation
  renderer: 'svg',
  loop: false,
  autoplay: false,
  path: 'https://lottie.host/51d2cccb-bd2c-4ded-854d-f1c1c59fc38f/PhMPSNlQCT.json' // the path to the animation JSON
});

// Function to set initial position based on screen width
const setInitialPosition = () => {
  if (window.innerWidth > 750) {
      gsap.set("#animationWindow", { yPercent: 15 });
  } else {
      gsap.set("#animationWindow", { xPercent: 0 });
  }
};

// Once the animation is loaded, set up the ScrollTrigger
animation.addEventListener('data_failed', () => {
  animation.destroy();
  document.getElementById('animationWindow').hidden = true;
});

animation.addEventListener('DOMLoaded', () => {
  document.getElementById('animationWindow').hidden = false;
  // Register the ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);

  // Ensure the animation container has full viewport height
  document.getElementById('animationWindow').style.height = '100vh';
  document.getElementById('animationWindow').style.width = '100vw';

  // Set the initial frame to 5% of the total frames
  const initialFrame = Math.floor(animation.totalFrames * 0.1);
  animation.goToAndStop(initialFrame, true);

  // Set initial position based on the current screen width
  setInitialPosition()


  // Create the ScrollTrigger instance
  ScrollTrigger.create({
      trigger: "#animationWindow",
      start: "top top",
      end: "top-=15%", // Adjust this value to control how long the animation should scroll
      scrub: 2, // Adjust the scrub value for smoother control
      pin: false,
      pinSpacing: false,
      markers: false,
      onLeave: () => {
          // Get the target element and add a class to it
          document.getElementById("animationWindow").classList.add("animationWindowLeave");
      },
      onEnterBack: () => {
          // Get the target element and remove a class from it
          document.getElementById("animationWindow").classList.remove("animationWindowLeave");
      }
  });

  // Control the Lottie animation based on scroll position
  gsap.to({}, {
      scrollTrigger: {
          trigger: "#animationWindow",
          start: window.innerWidth > 750 ? "top-=15% top" : "top top",
          end: window.innerWidth > 750 ? "+=65%" : "+=45%", // Match the ScrollTrigger duration
          markers: false,
          scrub: 3,
          onUpdate: self => {
              const frame = initialFrame + self.progress * (animation.totalFrames - initialFrame - 1);
              animation.goToAndStop(frame, true);
          }
      }
  });

  // Add a resize event listener to handle screen resizing
window.addEventListener('resize', () => {
  const animationWindow = document.getElementById('animationWindow');
  if (window.innerWidth < 750) {
      animationWindow.classList.add("animationWindowMobile");
  } else {
      animationWindow.classList.remove("animationWindowMobile");
  }
});
});






}

if (document.getElementById("animationStore")) LottieScrollTrigger({
    target: "#animationStore",
    path: "https://lottie.host/9bec02ba-5529-4285-878c-7ee5b7d953bd/GJf8hZgzA5.json",
    speed: "medium",
    pinSpacing: false,
    pin: false,
    start: "top bottom",
    end: "top 40%",
    scrub: 2 // seconds it takes for the playhead to "catch up"
    // you can also add ANY ScrollTrigger values here too, like trigger, start, end, onEnter, onLeave, onUpdate, etc. See https://greensock.com/docs/v3/Plugins/ScrollTrigger
   });
   
   function LottieScrollTrigger(vars) {
       let playhead = {frame: 0},
           target = gsap.utils.toArray(vars.target)[0],
           speeds = {slow: "+=2000", medium: "+=1000", fast: "+=500"},
           st = {trigger: target, pin: true, start: "top top", end: speeds[vars.speed] || "+=1000", scrub: 1},
           ctx = gsap.context && gsap.context(),
           animation = lottie.loadAnimation({
               container: target,
               renderer: vars.renderer || "svg",
               loop: false,
               autoplay: false,
               path: vars.path,
               rendererSettings: vars.rendererSettings || { preserveAspectRatio: 'xMidYMid slice' }
           });
           for (let p in vars) { // let users override the ScrollTrigger defaults
               st[p] = vars[p];
           }
       animation.addEventListener("data_failed", () => {
         animation.destroy();
         target.hidden = true;
       });
       animation.addEventListener("DOMLoaded", function() {
         let createTween = function() {
            animation.frameTween = gsap.to(playhead, {
               frame: animation.totalFrames - 1,
               ease: "none",
               onUpdate: () => animation.goToAndStop(playhead.frame, true),
               scrollTrigger: st
           });
           return () => animation.destroy && animation.destroy();
         };
         ctx && ctx.add ? ctx.add(createTween) : createTween();
         // in case there are any other ScrollTriggers on the page and the loading of this Lottie asset caused layout changes
         ScrollTrigger.sort();
         ScrollTrigger.refresh();    
       });
       return animation;
   }

//    section animation
gsap.utils.toArray('.j_snap_panel').forEach((panel) => {
    ScrollTrigger.create({
      trigger: panel,
      start: 'top top',
      pin: true,
      pinSpacing: false,
    });
  });


//   SERVICE CURSOR ANIMATION
class Follower {
  constructor({ delay = 0.2, count = 5 }) {
    this.count = count;
    this.delay = delay / 10;
    this.init();
  }

  init() {
    this.followers = [];
    this._creatCursor();
    this._creatFollowers();
    this._setSize();
    this._setInitialPos();
    this._addEventListeners();
  }

  _creatElem(className) {
    const elem = document.createElement("div");
    elem.className = className;
    document.body.appendChild(elem);
    return elem;
  }
  _creatCursor() {
    this.cursor = this._creatElem("cursor");
  }
  _creatFollowers() {
    for (let i = 0; i < this.count; i++) {
      const f = this._creatElem("follower");
      this.followers.push(f);
    }
  }
  _setSize() {
    let prev;

    this.followers.forEach(follower => {
      !prev ? (prev = this.cursor) : null;

      const rect = prev.getBoundingClientRect();
      gsap.set(follower, {
        width: rect.width * 0.75,
        height: rect.height * 0.75
      });
      prev = follower;
    });
  }
  _setInitialPos() {
    this.x = innerWidth / 2;
    this.y = innerHeight / 2;
    gsap.set([this.cursor, this.followers], {
      x: this.x,
      y: this.y
    });
  }
  _addEventListeners() {

    //get the target element with class service-2
    const service2 = document.querySelector(".service-2");

    if (!service2) {
      console.error("Element with class 'service-2' not found.");
      return;
    }

    service2.addEventListener("mouseenter", () => {
        //animate the clippath from class overlay to 100px with gsap
        gsap.to(".overlay", {
            duration: 0.5,
            clipPath: "circle(100px at var(--mouse-x) var(--mouse-y))",
            ease: "power2.inOut"
        });
    });

    service2.addEventListener("mouseleave", () => {
        //animate the clippath from class overlay to 100px with gsap
        gsap.to(".overlay", {
            duration: 0.5,
            clipPath: "circle(0px at var(--mouse-x) var(--mouse-y))",
            ease: "power2.inOut"
        });
    });


    service2.addEventListener("mousemove", event => {
      const e = event.touches ? event.touches[0] : event;
      var rect = service2.getBoundingClientRect();
      this.x = e.clientX - rect.left;
      this.y = e.clientY - rect.top;
      
      document.documentElement.style.setProperty('--mouse-x', this.x + 'px')
      document.documentElement.style.setProperty('--mouse-y', this.y + 'px')

      
      gsap.to(this.cursor, { duration: 0, x: this.x, y: this.y });
      gsap.to(this.followers, {
        duration: 0.2,
        x: this.x,
        y: this.y,
        stagger: this.delay
      });
    });
  }
}

if (document.querySelector(".service-2") && window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
  new Follower({ delay: 0.2, count: 5 });
}
})();


